var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"gb mobile",attrs:{"id":"inspire"}},[_c('div',{staticClass:"module-container"},[_c('div',{staticClass:"home"},[_c('div',{staticClass:"banner"},[_c('img',{attrs:{"src":require('@/assets/logo.svg'),"alt":""}}),_c('p',[_vm._v(" Disable Email Notifications ")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }